{
  "version": "0.2.12",
  "extensionId": "objhnmnodmnmjiegkddnfgbjbhfohokm",
  "sha256": "86bd18ffdb14e6bf4b0158d6f901a75cfd677f69d7bb2d91dcbdc904862b8b5b",
  "bytes": 81947,
  "download": "https://gab.ai/browser-extension/gab-ai-browser-extension-preview.zip",
  "channel": "manual-preview",
  "chatOrigin": "https://gab.ai"
}
